"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeMeetingStatsRow () {
        return EmployeeMeetingStatsRow;
    },
    get GetEmployeeMeetingStatsSearchServiceResponse () {
        return GetEmployeeMeetingStatsSearchServiceResponse;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const EmployeeMeetingStatsRow = _zod.z.object({
    employeeId: _utilsisomorphic.transformObjectId,
    employeeName: _zod.z.string(),
    managerId: _utilsisomorphic.transformObjectId.nullable(),
    managerName: _zod.z.string().nullable(),
    /** Department name — a "Group" in product terms. */ group: _zod.z.string().nullable(),
    /** Combined count of workspaces the employee created / participates in. */ workspaceCount: _zod.z.number(),
    /** Meetings the employee participates in, within the selected date window. */ allMeetingsCount: _zod.z.number(),
    /** 1:1 meetings (<= 2 participants) that include the employee's current manager. */ oneOnOneWithManagerCount: _zod.z.number(),
    /** Team meetings (> 2 participants). Null when team meetings are disabled for the company. */ teamMeetingsCount: _zod.z.number().nullable()
});
const GetEmployeeMeetingStatsSearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: EmployeeMeetingStatsRow.array()
});
